import React, { useRef } from 'react'

import { CheckIcon } from '@chakra-ui/icons'
import { Button, ButtonProps } from '@chakra-ui/react'

import { CopyIconSVG } from '@/views/assets/CopyIconSVG'
import {
  copyContentToClipboard,
  copyDivToClipboard,
} from '@/views/utils/copyDivToClipboard'

type CopyButtonProps = ButtonProps & {
  textCopy?: string
  iconColor?: string
  contentRef?: React.RefObject<HTMLElement | null>
  textContent?: Record<string, string>
}

export const CopyContentButton = ({
  contentRef,
  textCopy = '',
  iconColor = 'white',
  textContent,
  ...props
}: CopyButtonProps) => {
  const [isRecentlyCopied, setIsRecentlyCopied] = React.useState<boolean>(false)

  const timeoutRef = useRef<NodeJS.Timeout | null>(null) // Store the timeout reference

  return (
    <Button
      onClick={() => {
        if (textContent) {
          copyContentToClipboard(textContent)
        } else {
          copyDivToClipboard(contentRef?.current || undefined)
        }
        setIsRecentlyCopied(true)

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
          setIsRecentlyCopied(false)
        }, 1000)
      }}
      variant={'brand-solid'}
      rounded={'1.25rem'}
      iconSpacing={textCopy ? '0.5rem' : '0'}
      leftIcon={
        isRecentlyCopied ? (
          <CheckIcon w={'1rem'} />
        ) : (
          <CopyIconSVG color={iconColor} width={'1rem'} />
        )
      }
      {...props}
    >
      {textCopy}
    </Button>
  )
}
